export const goalTypes = [
  "Career",
  "Diet",
  "Financial",
  "Fitness",
  "Food",
  "Health",
  "Learning",
  "Mental wellness",
  "Reading",
  "Shopping",
  "Skills",
  "Social",
  "Work",
].sort();
export const redemptionPages = [
  "Polls",
  "iD",
  "Members",
  "Friends",
  "My Day",
  "Feeds",
  "My Timeline",
  "Wallets",
  "Spend Tokens",
  "Shop",
  "Token Offers",
  "Event",
].sort();



// WEBPACK FOOTER //
// ./src/screens/GamificationGoals/constants/selections.js